import { ReactElement, useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid2 as Grid,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { getAllUsers, createUser, updateUser } from "services/UserService";
import { Item } from "../shared/Item";
import EditUserModal from "components/settings/EditUserModal";

const currentUserId = 1;
const isAdmin = true;

const UserSettings = (): ReactElement => {
  const [users, setUsers] = useState<User[]>([]);
  const [formData, setFormData] = useState({
    username: "",
    name: "",
    password: "",
  });
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [userToEdit, setUserToEdit] = useState<User | null>(null);

  const fetchUsers = async () => {
    const data = await getAllUsers();
    setUsers(data);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleCreate = async () => {
    if (!formData.username || !formData.name || !formData.password) return;
    await createUser({
      username: formData.username,
      name: formData.name,
      key: btoa(formData.password),
    });
    setFormData({ username: "", name: "", password: "" });
    fetchUsers();
  };

  const handleToggleActive = async (user: User) => {
    if (!isAdmin || user.id === currentUserId) return;
    await updateUser({
      id: user.id,
      username: user.username,
      name: user.name,
      activo: !user.activo,
    });
    fetchUsers();
  };

  const handleEdit = (user: User) => {
    if (!isAdmin || user.id === currentUserId) return;
    setUserToEdit(user);
    setEditModalOpen(true);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Administración de Usuarios
      </Typography>

      {/* Formulario */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid size={3}>
          <TextField
            fullWidth
            label="Username"
            name="username"
            variant="standard"
            value={formData.username}
            onChange={handleChange}
          />
        </Grid>
        <Grid size={4}>
          <TextField
            fullWidth
            label="Full Name"
            name="name"
            variant="standard"
            value={formData.name}
            onChange={handleChange}
          />
        </Grid>
        <Grid size={3}>
          <TextField
            fullWidth
            label="Contraseña"
            name="password"
            type="password"
            variant="standard"
            value={formData.password}
            onChange={handleChange}
          />
        </Grid>
        <Grid size={2}>
          <Button fullWidth variant="contained" onClick={handleCreate}>
            Crear
          </Button>
        </Grid>
      </Grid>

      {/* Tabla */}
      <Grid container spacing={1}>
        <Grid size={3}>
          <Item>Username</Item>
        </Grid>
        <Grid size={5}>
          <Item>Nombre</Item>
        </Grid>
        <Grid size={2}>
          <Item>Acciones</Item>
        </Grid>
        <Grid size={2}>
          <Item>Activo</Item>
        </Grid>

        {users.map((user) => (
          <>
            <Grid size={3}>
              {user.username}
            </Grid>
            <Grid size={5}>
              {user.name}
            </Grid>
            <Grid size={2}>
              {isAdmin && user.id !== currentUserId ? (
                <Button onClick={() => handleEdit(user)}>Editar</Button>
              ) : null}
            </Grid>
            <Grid size={2}>
              {isAdmin && user.id !== currentUserId ? (
                <Switch
                  checked={user.activo === 1 ? true: false}
                  onChange={() => handleToggleActive(user)}
                />
              ) : (
                <Switch checked={user.activo === 1 ? true: false} disabled />
              )}
            </Grid>
          </>
        ))}
      </Grid>

      {/* Modal de edición */}
      {userToEdit && (
        <EditUserModal
          open={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          user={userToEdit}
          reload={fetchUsers}
        />
      )}
    </Box>
  );
};

export default UserSettings;
